/** SA-922: a failed credential write's body, worded. `view_as_forbidden` says
 * the keys are the person's own; every other body is SA-989's one reader, so
 * a bare object is never printed. */
import { viewAsForbiddenText } from '@/components/auth/impersonationText'
import { errorDetailText } from '@/utils/errorDetail'

export function credentialErrorText(body: unknown, fallback: string): string {
  const detail = body && typeof body === 'object' && 'detail' in body ? (body as { detail: unknown }).detail : undefined
  if (detail && typeof detail === 'object' && (detail as { code?: unknown }).code === 'view_as_forbidden') {
    return viewAsForbiddenText()
  }
  return errorDetailText(body, fallback)
}
